globalThis.backoffice = globalThis.backoffice || {};

$(function() {
  // Default initialization
  backoffice.initSelect2 = function($selects) {
    $selects.each(function(){
      var $this = $(this);

      options = {
        minimumResultsForSearch: Infinity,
        placeholder: $this.attr('placeholder') || "",
        allowClear: $this.hasClass('allow-clear')
      }

      if($this.data('select2-data')) {
        options.data = $this.data('select2-data');
        options.escapeMarkup = function(markup) {
          return markup;
        },
        options.templateResult = function(data) {
          return data.html;
        },
        options.templateSelection = function(data) {
          return data.html;
        }
      }
      $this.select2(options);
    });
  }
  backoffice.initSelect2($('.select'));
  // Select with search
  backoffice.initSelect2Search = function($selects) {
    var initSelects = function() {
      $selects.each(function() {
        var $this = $(this);

        $this.select2({
          dropdownParent: $this.parent(),
          placeholder: $this.attr('placeholder') || "",
          allowClear: $this.hasClass('allow-clear'),
          matcher: backoffice.select2Matcher
        });
      });
    }

    if(backoffice.select2Matcher) {
      initSelects();
    } else {
      $.fn.select2.amd.require(['select2/diacritics'], function (DIACRITICS) {
        function stripDiacritics (text) {
          // Used 'uni range + named function' from http://jsperf.com/diacritics/18
          function match(a) {
            return DIACRITICS[a] || a;
          }

          return text.replace(/[^\u0000-\u007E]/g, match);
        }

        backoffice.select2Matcher = function(term, text) {
          var original = stripDiacritics(text.text).toUpperCase();
          var term = stripDiacritics(term.term || '').toUpperCase();

          if(text.children) {
            var filteredChildren = [];
              $.each(text.children, function (idx, child) {
                if ((new RegExp(term, 'gi')).test(stripDiacritics(child.text).toUpperCase())) {
                  filteredChildren.push(child);
                }
              });

              if (filteredChildren.length) {
                var modifiedData = $.extend({}, text, true);
                modifiedData.children = filteredChildren;

                return modifiedData;
              }
          } else {
            if ((new RegExp(term, 'gi')).test(original + (text.element.dataset.keywords || ''))) {
              return text;
            } else {
              return null;
            }
          }
        }

        initSelects();
      });
    }
  }
  backoffice.initSelect2Search($('.select-search'));
  // Fixed width. Single select
  $('.select-fixed-single').select2({
    minimumResultsForSearch: Infinity,
    width: 250
  });
  // Fixed width. Multiple selects
  $('.select-fixed-multiple').select2({
    minimumResultsForSearch: Infinity,
    width: 400
  });

  $('.multiselect').each(function(){
    $(this).multiselect({
      buttonWidth: $(this).data('width') || 250,
      nonSelectedText: $(this).attr('placeholder') || "Sélectionnez...",
      templates: {
          filter: '<li class="multiselect-item multiselect-filter"><i class="icon-search4"></i> <input class="form-control" type="text"></li>'
      },
      onChange: function() {
          $.uniform.update();
      }
    });
  });

  $('.tags').each(function() {
    var $this = $(this),
        defaults = {
          language: {
            noResults: function () {
              return 'Aucun résultat';
            },
            searching: function () {
              return 'Recherche...';
            }
          },
          tags: true,
          tokenSeparators: [',']
        },
        options = {};

    if($this.data('ajax-url')) {
      options.ajax = {
        url: $this.data('ajax-url'),
        dataType: 'json',
        delay: 250,
        processResults: function(data) {
          return {
            results: data.items
          }
        },
        cache: true
      }
    }

    $this.select2($.extend({}, defaults, options));
  });

  // Advanced Select with subinfos
  $(".select-advanced").each(function(){
    var $this = $(this);
    $this.select2({
      data: $this.data('options'),
      placeholder: $this.attr('placeholder') || "",
      allowClear: $this.hasClass('allow-clear'),
      closeOnSelect: !$this.attr('multiple'),
      containerCssClass: $this.attr('class'),
      templateResult: function(data) {
        if (data.loading) return data.text;

        var markup = "<div class='select2-result-repository clearfix'>" +
            "<div class='select2-result-repository__meta'>" +
              "<div class='select2-result-repository__title'>" + data.text + "</div>";

        if (data.subtext) {
          markup += "<div class='select2-result-repository__description'>" + data.subtext + "</div>";
        }

        if(data.subinfo_1 || data.subinfo_2 || data.subinfo_3) {
          markup += "<div class='select2-result-repository__statistics'>";

          if(data.subinfo_1) {
            markup += "<div class='select2-result-repository__forks'>" + data.subinfo_1 + "</div>";
          }
          if(data.subinfo_2) {
            markup += "<div class='select2-result-repository__stargazers'>" + data.subinfo_2 + "</div>";
          }
          if(data.subinfo_3) {
            markup += "<div class='select2-result-repository__watchers'>" + data.subinfo_3 + "</div>";
          }

          markup += "</div>";
        }

        markup += "</div></div>";

        return $(markup);
      }
    });
  });

  // Select AJAX
  backoffice.initSelect2Ajax = function($selects) {
    $selects.each(function() {
      var $this = $(this);
      $this.select2({
        ajax: {
          url: $this.data('fetch-url'),
          dataType: 'json',
          delay: 250,
          data: function (params) {
            return {
              q: params.term,
              page: params.page
            };
          },
          processResults: function (data, params) {
            // parse the results into the format expected by Select2
            // since we are using custom formatting functions we do not need to
            // alter the remote JSON data, except to indicate that infinite
            // scrolling can be used
            params.page = params.page || 1;
            return {
              results: data.results,
              pagination: {
                more: (params.page * 30) < data.total_count
              }
            };
          },
          cache: true
        },
        escapeMarkup: function (markup) { return markup; },
        placeholder: $this.attr('placeholder') || 'Rechercher...',
        minimumInputLength: 1,
        maximumSelectionLength: $this.data('max-selection'),
        allowClear: true,
        templateResult: function(data) {
          if (data.loading) return data.text;

          return data.html;
        }
      });
    });
  }
  backoffice.initSelect2Ajax($('.select-ajax'));
});
